import { _ } from "../polyglot/polyglot.js";
import AccountingCoordinator from "../../accounting/shared/documentInfrastructure/AccountingCoordinator.js";
import AccountingDocument from "../../accounting/shared/documentInfrastructure/AccountingDocument2/AccountingDocument.js";
import AccountingDocumentState from "../../accounting/shared/documentInfrastructure/AccountingDocumentState.js";
import ReleaseNotesDocumentContent from "./ReleaseNotesDocumentContent.js";
import ReleaseNotesDocumentService from "./ReleaseNotesDocumentService.js";
import session from "../session.js";
import TitleWidget from "../chrome/TitleWidget2.js";

/**
 * Create and return a new release notes document.
 */
export default function makeReleaseNotesDocument() {
	const coordinator = new AccountingCoordinator({
		documentState: new AccountingDocumentState({
			service: new ReleaseNotesDocumentService({ session }),
		}),
		renderables: {
			content: new ReleaseNotesDocumentContent(),
			title: new TitleWidget({ title: _("What's new?") }),
			periodPicker: false,
		},
	});

	return new AccountingDocument({ coordinator });
}
